export default __webpack_public_path__ + "img/c75004097c5e7b5225336278d1922567.svg";